import { VolunteerSlotCardSkeleton } from '@sola/ark-skippy/molecules/volunteer-slot-card/volunteer-slot-card.tsx';

import { VolunteerEventInfoSkeleton } from '../../molecules/volunteer-event-info/volunteer-event-info.tsx';

export const VolunteerSkeleton = () => {
  return (
    <div className="flex max-w-md flex-col gap-comfy-xl">
      <VolunteerEventInfoSkeleton />
      <div className="grid grid-cols-1 gap-comfy-sm md:grid-cols-2">
        <VolunteerSlotCardSkeleton />
        <VolunteerSlotCardSkeleton />
        <VolunteerSlotCardSkeleton />
      </div>
    </div>
  );
};
